<div class="card secondary with-content payment-card" dir="ltr">
  <form [action]="returnUrl" class="paymentWidgets" data-brands="VISA MASTER MADA"></form>
</div>
